import React, { Component } from 'react';
import { func, string, array } from 'prop-types';
import { translate, Trans } from 'react-i18next';
import classnames from 'classnames/bind';

import { TH } from '@snapask/common-components/dist/constants/locales';

import { Button, Modal, SnapaskLoader } from '@snapask/common-components';
import LineInput from '@dragonfruit/components/fields/LineInput';
import LineSelect from '@dragonfruit/components/fields/LineSelect';

import { NEW_PASSWORD, EMAIL } from '@dragonfruit/constants/autocompleteFields';
import { thailandTutorPageURL } from '@dragonfruit/constants/externalLinks';
import config from '@dragonfruit/config';
const { TUTOR_ONBOARDING_TH_REDIRECT } = config;
import Validator from '@dragonfruit/utils/validator';

import styles from './TutorSignupForm.scss';
import modalTheme from './modalTheme.scss';
const cx = classnames.bind(styles);

class TutorSignupForm extends Component {
  static propTypes = {
    regionList: array.isRequired,
    t: func.isRequired,
    onSelectCountry: func.isRequired,
    onSubmit: func.isRequired,
  };

  static contextTypes = {
    urlLocale: string,
  };

  state = {
    selectedRegion: {},
    password: '',
    passwordError: '',
    email: '',
    emailError: '',
    confirmPolicy: false,
    confirmPolicyError: '',
  };

  onChangeRegion = region => {
    const { name } = region;

    const { onSelectCountry } = this.props;

    // if users select Thailand, we need to direct them to Thailand's tutor signup page.
    if (TUTOR_ONBOARDING_TH_REDIRECT === 'true' && name === TH) {
      window.open(thailandTutorPageURL, '_self');
    }

    this.setState({
      selectedRegion: region,
    });

    onSelectCountry(region);
  };

  onConfirmPolicy = event => {
    const { checked } = event.target;
    this.setState({
      confirmPolicy: checked,
    });
    this.checkConfirmPolicy();
  };

  handlePasswordChange = value => this.setState({ password: value });
  handleEmailChange = value => this.setState({ email: value });

  checkPassword = () => {
    const { t } = this.props;
    let validate = new Validator(this.state.password).isEmpty(
      t('error:error.fieldEmpty')
    );

    validate = validate.isPassword(
      t('error:error.not-satisfy-password-pattern')
    );

    const error = validate.getFirstErrorMessage();
    this.setState({ passwordError: error });
  };

  checkEmail = () => {
    const { t } = this.props;
    const validate = new Validator(this.state.email)
      .isEmpty(t('error:error.fieldEmpty'))
      .isEmail(t('error:error.must-be-email-pattern'));
    const error = validate.getFirstErrorMessage();

    this.setState({ emailError: error });
  };
  checkConfirmPolicy = () => {
    const { t } = this.props;
    this.setState(prev => ({
      confirmPolicyError: !prev.confirmPolicy
        ? t('error:error.mustCheckPolicy')
        : '',
    }));
  };
  isValidToSubmit = () => {
    const {
      selectedRegion,
      passwordError,
      emailError,
      confirmPolicy,
    } = this.state;
    if (passwordError || emailError || !selectedRegion.value || !confirmPolicy)
      return false;

    return true;
  };

  handleSubmit = () => {
    const { selectedRegion, password, email } = this.state;
    this.checkConfirmPolicy();
    if (!this.isValidToSubmit()) return;

    this.props.onSubmit({
      email,
      password,
      region: selectedRegion,
    });
  };

  render() {
    const { t, regionList } = this.props;
    const { urlLocale } = this.context;
    const {
      selectedRegion,
      passwordError,
      emailError,
      email,
      confirmPolicyError,
    } = this.state;

    const regionOptions = regionList.map(region => ({
      label: region.fullName,
      value: region.id,
      ...region,
    }));

    const { name } = selectedRegion;

    return (
      <div>
        {TUTOR_ONBOARDING_TH_REDIRECT === 'true' && name === TH && (
          <Modal staticModal onClose={() => {}} theme={modalTheme}>
            <SnapaskLoader />
          </Modal>
        )}
        <div className={styles.field}>
          <LineSelect
            floatingLabelText={t('fieldLabel:fieldLabel.region')}
            options={regionOptions}
            clearable={false}
            onChange={this.onChangeRegion}
            value={selectedRegion.value}
            searchable
            openOnFocus
            openOnClick
          />
        </div>

        <div className={styles.field}>
          <LineInput
            floatingLabelText={t('fieldLabel:fieldLabel.email')}
            autoComplete={EMAIL}
            value={email}
            onChange={this.handleEmailChange}
            onBlur={this.checkEmail}
            errorText={!!emailError && emailError}
          />
        </div>

        <div className={styles.field}>
          <LineInput
            type="password"
            floatingLabelText={t('fieldLabel:fieldLabel.password')}
            autoComplete={NEW_PASSWORD}
            onChange={this.handlePasswordChange}
            onBlur={this.checkPassword}
            errorText={!!passwordError && passwordError}
          />
        </div>

        <div className={styles.policy}>
          <label>
            <input
              onChange={this.onConfirmPolicy}
              type="checkbox"
              className={styles.policyCheck}
            />
            <span
              className={cx(styles.checkMark, {
                error: !!confirmPolicyError,
              })}
            />
            <p>
              <Trans i18nKey="tutorSignup.policyConfirmText">
                Please agree to Snapask’s
                <a
                  href={`/${urlLocale}/terms?role=tutor`}
                  target="_blank"
                  rel="noreferrer"
                >
                  terms
                </a>
                and
                <a
                  href={`/${urlLocale}/privacy`}
                  target="_blank"
                  rel="noreferrer"
                >
                  policy
                </a>
                .
              </Trans>
            </p>
          </label>
          {confirmPolicyError && (
            <small className={styles.error}>{confirmPolicyError}</small>
          )}
        </div>

        <Button
          type="submit"
          text={t('fieldLabel:fieldLabel.signup')}
          primary
          onClick={this.handleSubmit}
        />
      </div>
    );
  }
}

export default translate(['tutorSignup', 'error', 'fieldLabel'])(
  TutorSignupForm
);



// WEBPACK FOOTER //
// ./app/components/TutorSignupForm/TutorSignupForm.jsx